module.exports = __webpack_public_path__ + "static/media/CARTOONAROONY 6.59ca4dc1.JPG";